import React from 'react'

import powerRangers from '../../images/POWER RANGERS 3 copy.jpg'
import powerRangers2 from '../../images/POWER RANGERS TITLE.jpg'
import powerRangers3 from '../../images/POWER RANGERS 3.jpg'

function PowerRangers() {
  return (
    <div className="Project-page container">
      <div className="row">
        <div className="col-md-6">
          <img
            src={powerRangers}
            className="project-image" />
          <img
            src={powerRangers2}
            className="project-image" />
          <img
            src={powerRangers3}
            className="project-image" />
        </div>
        <div className="Project-content col-md-6">
          <h1>Power Rangers</h1>
          <p className="Project-text">
            <strong>POWER RANGERS
            Television Series, season 27/28
<br />
Hasbro
<br />
Directors: Charlie Haskell, Chris Graham, Caroline Bell Booth
<br />
2020 - 2021

<br />
              <br />
Rehearsal + On set Acting Coach
<br />
Coaching the 6 Rangers (ages 20, 22, 23, 23, 25, 33)

            </strong>
          </p>
          <p className="Project-testimonial">
            "For us rangers, it was either our first acting job, or our first big full force role. Having someone as educated and as open as Ella really helped us become our characters. She allowed us to feel safe in our space and safe with each other to open up about anything and everything. Within that, we all just let loose and showed each other what we are capable of. Ella can answer any questions you have and help you feel comfortable with your own choices. She helps you learn your character inside and out so that you can feel great about all the decisions you make.
            Her next project doesn’t know how lucky they are to have her.
            ”
          </p>
          <h6 className="Testimonial-person">
            <strong>~Hunter Deno, Dino Fury’s Pink Power Ranger
</strong>
          </h6>
          <p className="Project-testimonial">
            "Ella Gilbert is incredible and I thank her for teaching me her methods, making me feel special and giving me the confidence to believe in myself and become a better actor.
            ”
          </p>
          <h6 className="Testimonial-person">
            <strong>~Chance Perez
, Dino Fury’s Black Power Ranger

</strong>
          </h6>
          <p className="Project-testimonial">
            "
Ella Gilbert is a truly exceptional acting coach. 
She is patient, kind and honest in the most refreshing and encouraging ways, and I would happily work with her again on ANY project. 
Thank you, Ella! You have not only prepared me for my first big role, you've helped me set a strong foundation for an entire career.

            ”
          </p>
          <h6 className="Testimonial-person">
            <strong>~Russell Curry
, Dino Fury’s Red Power Ranger

</strong>
          </h6>
          <p className="Project-testimonial">
            "Ella was able to bring the most out of my craft and pushed my abilities to the limit. She helped me relax and become more comfortable when approaching challenging scenes. 
            ”
          </p>
          <h6 className="Testimonial-person">
            <strong>~Kai Moya
, Dino Fury’s Blue Power Ranger

</strong>
          </h6>
        </div>
      </div>
    </div>
  )
}

export default PowerRangers
